import { WebDPrivilege } from "api/services/models/WebDUser";
import { useTDAuthentication } from "auth/AuthenticationProvider";
import { ReactComponent as RolesIcon } from "Icons/vuesax/briefcase.svg";
import { ReactComponent as LocationsIcon } from "Icons/vuesax/buildings-2.svg";
import { ReactComponent as ReportTypesIcon } from "Icons/vuesax/message-edit.svg";
import { ReactComponent as ProvidersIcon } from "Icons/vuesax/people.svg";
import { ReactComponent as RefProvidersIcon } from "Icons/vuesax/profile-2user.svg";
import { ReactComponent as AccountIcon } from "Icons/vuesax/shop.svg";
import { ReactComponent as UsersIcon } from "Icons/vuesax/user.svg";
import { ReactComponent as HamburgerIcon } from "Icons/vuesax/menu.svg";
import { useLayoutContext } from "components/MainContainer";
import { Button, GetProp, Tabs, TabsProps } from "antd";
import ManageDocumentTypes from "components/document-types/ManageDocumentTypes";
import ManageAccount from "./accounts/ManageAccount";
import ManageLocations from "./locations/ManageLocations";
import ManageContacts from "./providers/ManageContacts";
import ManageRefProviders from "./ref-providers/ManageRefProviders";
import ManageRoles from "./roles/ManageRoles";
import ManageUsers from "./users/ManageUsers";
import { useEffect } from "react";

type TTab = GetProp<TabsProps, "items">[0] & { privilege: WebDPrivilege };

const tabs: TTab[] = [
  {
    key: "Account",
    icon: <AccountIcon className="anticon settings-icon" />,
    label: "Account",
    children: <ManageAccount />,
    privilege: WebDPrivilege.ManageAccount
  },
  {
    key: "Locations",
    icon: <LocationsIcon className="anticon settings-icon" />,
    label: "Locations",
    destroyInactiveTabPane: true,
    children: <ManageLocations />,
    privilege: WebDPrivilege.ManageLocations
  },
  {
    key: "Providers",
    icon: <ProvidersIcon className="anticon settings-icon" />,
    label: "Providers / Contacts",
    destroyInactiveTabPane: true,
    children: <ManageContacts />,
    privilege: WebDPrivilege.ManageContacts
  },
  {
    key: "RefProviders",
    icon: <RefProvidersIcon className="anticon settings-icon" />,
    label: "Referring Providers",
    destroyInactiveTabPane: true,
    children: <ManageRefProviders />,
    privilege: WebDPrivilege.ManageContacts
  },
  {
    key: "DocumentTypes",
    icon: <ReportTypesIcon className="anticon settings-icon" />,
    label: "Document Types",
    children: <ManageDocumentTypes />,
    privilege: WebDPrivilege.ManageAccount
  },
  {
    key: "Users",
    icon: <UsersIcon className="anticon settings-icon" />,
    label: "Users",
    children: <ManageUsers />,
    privilege: WebDPrivilege.EditUser
  },
  {
    key: "Roles",
    icon: <RolesIcon className="anticon settings-icon" />,
    label: "Roles",
    destroyInactiveTabPane: true,
    children: <ManageRoles />,
    privilege: WebDPrivilege.ManageAccountRoles
  }
];

const privileges = [
  WebDPrivilege.ManageAccount,
  WebDPrivilege.EditUser,
  WebDPrivilege.ManageAccountRoles,
  WebDPrivilege.ManageContacts,
  WebDPrivilege.ManageLocations
];

const AccountSettings = () => {
  const { webDUser } = useTDAuthentication();
  const { toggleDrawer, isSmallScreen } = useLayoutContext();
  if (!webDUser?.hasAnyPrivilege(privileges)) {
    return <div>Forbidden</div>;
  }

  useEffect(() => {
      document.body.classList.toggle("no-scroll", !isSmallScreen);
  }, [isSmallScreen]);

  return (
    <div className="container">
      <div className="header">
        <div className="header-title">
          {isSmallScreen && (
            <Button
              type="text"
              icon={<HamburgerIcon />}
              onClick={toggleDrawer}
              className="hamburger-menu-button"
              style={{ marginRight: ".25rem" }}
            />
          )}
          <span>Settings</span>
        </div>
      </div>
      <Tabs
        destroyInactiveTabPane={true}
        defaultActiveKey="1"
        items={tabs.filter(t => webDUser?.hasPrivilege(t.privilege) && (t.key !== "Account" || webDUser?.isInternalUser()))}></Tabs>
    </div>
  );
};

export default AccountSettings;
